import React from 'react';
export function AnnouncementBar() {
  return <div className="bg-gold text-white py-2 px-4 text-center text-sm font-semibold tracking-wide w-full z-50 relative" data-id="element-25">
      🌸 ESPECIAL MES DE LA MUJER: 80% OFF — SOLO QUEDAN 47 CUPOS A ESTE PRECIO
    </div>;
}